import React from 'react';
import { useSiteConfig } from '@/lib/siteConfig';

const Stars = ({ n }) => (
  <span className="text-amber-400 tracking-wider" aria-label={`${n} out of 5 stars`}>{'★'.repeat(n)}<span className="text-gray-300">{'★'.repeat(5 - n)}</span></span>
);

// Admin-managed testimonials. Renders nothing until at least one is published, so a
// page never shows an empty "What people say" box or invented quotes.
const Testimonials = ({ className = '' }) => {
  const { config } = useSiteConfig();
  const items = config.testimonials || [];
  if (!items.length) return null;
  return (
    <section className={`bg-white rounded-3xl shadow-sm p-6 sm:p-8 ${className}`} aria-labelledby="testimonials-h">
      <h2 id="testimonials-h" className="text-2xl font-bold text-gray-800 mb-5 text-center">What people say</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((t) => (
          <figure key={t.id} className="rounded-2xl bg-indigo-50/60 p-5">
            <Stars n={t.rating || 5} />
            <blockquote className="text-gray-700 mt-2 mb-3">“{t.text}”</blockquote>
            <figcaption className="text-sm"><b className="text-gray-800">{t.name}</b>{t.role && <span className="text-gray-500"> · {t.role}</span>}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
